<ion-header class="ion-no-border">
  <ion-toolbar></ion-toolbar>
</ion-header>